module.exports = __webpack_public_path__ + "static/media/bad-react.4efdf879.png";